/**
 * @Author:      ge.yuankai
 * @DateTime:    2018-04-18
 * @Description: 播放视频的服务
 */
"use strict";
angular.module("playVideoModule", []).
controller("playVideoCtrl", ["$scope", "$modalInstance", 'httpService', 'id', 'type', 'isBackstage', '$sce', '$interval',function($scope, $modalInstance, httpService, id, type, isBackstage, $sce, $interval) {
    initStatus();
    initData();

    function initStatus() {
        $scope.status = {
            id: id,
            type: type,
            videoUrl: '',
            audioName: '',
            isClose: false,
            isBackstage: isBackstage
        }
        $scope.data = {
            typeObj: {
                video: '视频',
                audio: '音频'
            }
        }
    };

    function initData() {
        downloadMedia();
    };

    /**
     * [startInterval description]设置定时器
     * @return {[type]} [description]
     */
    function startInterval() {
        $interval.cancel($scope.data.fastVideoTimer);
        $scope.data.fastVideoTimer = $interval(function() {
            downloadMedia();
        }, 1000 * 8);
    }

    function downloadMedia() {
        console.log($scope.status.type);
        var url = "";
        var params = {};
        if ($scope.status.isBackstage) {
            url = "/mcnadmin/web/cloud/getVideoUrl.do";
            var libType;
            if($scope.status.type=='audio'){
                libType=201;
            }else if($scope.status.type=='video'){
                libType=101;
            }
            params = { 
                id: $scope.status.id,
                libType: libType
            };
        } else {
            url = "/mcnww/web/cloud/getVideoUrl.do";
            var libType;
            if($scope.status.type=='audio'){
                params = {
                    id: $scope.status.id,
                    libType: 201
                }
            }else if($scope.status.type=='video'){
                url = "/transfer/aav/video/detail";
                params = {
                    tenantId: '3',
                    userId: 'AAAABQAMdGVzdEB0cnMuY29tABx0ZXN0QHRycy5jb20sMywxNTc4ODg4Nzg1Nzk4AAAALzAtAhUAkYbTEsbpfqXrVG9_psU_CpwT5lkCFFw1Gq_Hk3yYL89R0fi3yw9f8koN',
                    videoId: $scope.status.id
                }
            }
        }
        httpService.http(url, params, "get").then(function(data) {
            if (data.data) {
                if (data.data.videoUrl) {
                    $scope.status.videoUrl = $sce.trustAsResourceUrl(data.data.videoUrl);
                }
                if (data.data.filename) {
                    $scope.status.audioName = data.data.filename;
                }
            }
            if (data.datas) {
                $scope.status.videoUrl = $sce.trustAsResourceUrl(data.datas.videourl);
                $scope.status.videoStatus = data.datas.status === 0 ? '转码中' : data.datas.status ==='-10'||data.datas.status ==='-2'?'转码失败':'转码完成';
            }
            if ($scope.status.videoStatus === '转码中') {
                if (!$scope.data.fastVideoTimer) {
                    startInterval();
                }
            } else {
                $interval.cancel($scope.data.fastVideoTimer);
            }
        });
    }
    $scope.cancel = function() {
        $interval.cancel($scope.data.fastVideoTimer);
        $scope.status.isClose = true;
        $modalInstance.dismiss();
    }
}]);